/**
 * Formata um valor em reais no padrão pt-BR: vírgula decimal e ponto de
 * milhar ("R$ 1.234,56"). Nunca use `toFixed` direto em valores de R$ na UI:
 * "R$ 46.8900" (custo de R$ 46,89) é lido como quarenta e seis mil reais.
 */
export const formatBRL = (
  value: number | null | undefined,
  minimumFractionDigits = 2,
  maximumFractionDigits = minimumFractionDigits,
): string =>
  `R$ ${Number(value || 0).toLocaleString("pt-BR", {
    minimumFractionDigits,
    maximumFractionDigits,
  })}`;

/**
 * Exibição de um campo de valor com máscara de centavos. O estado interno
 * continua "25.50" (lido com parseFloat e enviado à API); na tela vira
 * "25,50" / "1.234,56". A máscara só lê dígitos, então reler o texto
 * exibido não muda o valor.
 */
export const formatAmountInput = (amount: string): string => {
  if (amount === "" || amount === null || amount === undefined) return "";
  const num = Number(amount);
  if (!Number.isFinite(num)) return amount;
  return num.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/** Número decimal em pt-BR sem símbolo de moeda (ex.: tamanho "9,1 MB", "1,5s"). */
export const formatDecimalBR = (value: number, fractionDigits = 1): string =>
  Number(value || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

/** Arredonda para 4 casas mantendo NÚMERO (célula numérica no XLSX/JSON). */
export const round4 = (value: unknown): number => Number(Number(value || 0).toFixed(4));

/**
 * Célula do CSV exportado (separador ";", padrão do Excel pt-BR): números saem
 * com vírgula decimal e sem separador de milhar — "0.0123" é lido como texto
 * ou data pelo Excel em português.
 */
export const toCsvCell = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  if (typeof value === "number" && Number.isFinite(value)) {
    return value.toLocaleString("pt-BR", { useGrouping: false, maximumFractionDigits: 4 });
  }
  return String(value);
};
